import {
  UserRoleEnum,
  PermissionKeysEnum,
  LocalBackupStateEnum,
  BusinessType,
} from '@/constants/enum'

export interface LoginCodeModel {
  code: string
  typeCode: string
  overdueTime: number
  ipAddress: string
  timestamp: number
}
export interface WorkspaceInfoModel {
  workspaceKey: string
  workspaceName: string
  workspacePortrait: string
  backupState: LocalBackupStateEnum
  payType: number
  probationTime: number
}
export interface LoginStateInfo {
  state: QcodeLoginStateEnum
  token: string
}

export interface UserModel {
  userKey: string
  userName: string
  userPortrait: string
  email: string
  isApiKey: boolean
  isBindGoogleAuth: boolean
}
// 扫码登录状态
export enum QcodeLoginStateEnum {
  INIT = 1, // 等待扫码
  WAITING = 2, // 已经扫码等待app确认
  SUCCESS = 3, // 成功
  CANCELED = 4, // 已取消
  INVALID = 5, // 已失效
}
export interface UserRelationsModel {
  workspaceName: string
  workspaceKey: string
  workspacePortrait: string
  isAuthorizedDevice: boolean
}
export interface SendEmailCodeDTO {
  email: string
  businessType: BusinessType
}
export interface WorkspaceMemberModel extends WorkspaceBasicInfoModel {
  userKey: string
  relationsKey: string
  workspaceKey: string
  workspaceName: string
  role: UserRoleEnum
  userName: string
  workspacePortrait: string
  workspaceKeySig: string
  permissions: PermissionItemModel[]
  isBindGoogleAuth: boolean
  email: string
}
export interface WorkspaceBasicInfoModel {
  workspaceKey: string
  workspaceName: string
  workspacePortrait: string
  backupState: LocalBackupStateEnum
}

export interface PermissionItemModel {
  hold: boolean
  permissionKey: PermissionKeysEnum
}
export interface EmailCodeDTO {
  createTime: number
  businessId: string
}
